document.addEventListener('DOMContentLoaded', () => {
	const backLink = document.querySelector('.link-back');

	if (backLink) {
		backLink.addEventListener('click', (e) => {
			e.preventDefault();

			// Если в истории больше одной записи, вернуться назад
			if (window.history.length > 1) {
				window.history.back();
			} else {
				// Если это страницы с "press-center" или "events"
				if (window.location.href.includes('press-center')) {
					window.location.href = '/press-center';
				} else if (window.location.href.includes('events')) {
					window.location.href = '/events';
				} else {
					// На всех других страницах вернуться на главную
					window.location.href = '/';
				}
			}
		});
	}
});
